import styled from '@emotion/styled';

export const MainBlock = styled.div<{ isOpen?: boolean }>`
  padding: 28px 28px 40px 28px;

  border-radius: 8px;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;
`;

export const Steps = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const CloseBlock = styled.div`
  position: absolute;
  min-width: 20px;
  min-height: 20px;

  top: 10px;
  right: 10px;
`;
